module.exports = __webpack_public_path__ + "assets/img/success.2b0f64d9.svg";